module.exports = __webpack_public_path__ + "img/value-up.6f9ba37e.svg";